export enum FormViewDefinitionHideHeader {
  Undefined = 0,
  False = 10,
  True = 20,
}

export enum FormViewDefinitionHideDescription {
  Undefined = 0,
  False = 10,
  True = 20,
}
export enum FormViewDefinitionHideColumnHeader {
  Undefined = 0,
  False = 10,
  True = 20,
}
export enum FormViewDefinitionHidePagination {
  Undefined = 0,
  False = 10,
  True = 20,
}
